


























import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import { Getter, Action, State } from 'vuex-class'
import {
  GET_JOB_ID,
  GET_SAMPLE,
  GET_MATCHER_FOR_DISPLAY,
  GET_IS_CONNECTED
} from '@/system/store/getter-types'
import { CREATE_MATCHER_FOR_DISPLAY, FETCH_JOB_BY_ID_ACTION, FETCH_RESERVATION_TYPES_ACTION } from '@/system/store/action-types'
import { JOB_STATUSES } from '@/constants'
import { IMatcherItem } from '@/features/matchFields/store'
import { IActionType, IStore } from '@/system/store'
import { IJob } from '@/features/job/store'
import MatchFieldsSelect from '@/features/matchFields/components/MatchFieldsSelect.vue'
import DualRing from '@/shared/loaders/LoaderDualRing.component.vue'

@Component({
  components: {
    MatchFieldsSelect
  }
})
export default class MatchFieldsList extends Vue {
  private pagination = {
    rowsPerPage: 0
  }
  selectedValue = ''
  columns = [
    {
      name: 'column',
      label: 'Column',
      align: 'left'
    },
    {
      name: 'assignedField',
      label: 'Assigned Field',
      align: 'left'
    },
    {
      name: 'sampleValue',
      label: 'Sample Value',
      align: 'left'
    }
  ]
  @Ref()
  readonly selectModal!: MatchFieldsSelect
  @State(({ job }: IStore) => job.job) job!: IJob
  @Getter(GET_SAMPLE)
  sample!: any[]
  @Getter(GET_MATCHER_FOR_DISPLAY)
  matcher!: IMatcherItem[]
  @Getter(GET_IS_CONNECTED)
  isConnected!: boolean
  @Action(CREATE_MATCHER_FOR_DISPLAY)
  createMatcher!: IActionType
  @Action(FETCH_JOB_BY_ID_ACTION)
  fetchJobId!: IActionType
  @Action(FETCH_RESERVATION_TYPES_ACTION)
  fetchReservationTypes!: IActionType

  @Watch('isConnected')
  getActualDataList () {
    this.getActualDataForMap()
  }

  @Watch('sample')
  changedSample () {
    if (this.sample.length) this.createMatcher(this.sample)
  }
  @Watch('matcher')
  hideLoader () {
    this.$q.loading.hide()
  }

  @Watch('job')
  watchJob () {
    const { jobId, status } = this.job
    const { PENDING, UPLOADED_CSV } = JOB_STATUSES
    if ([PENDING, UPLOADED_CSV].includes(status as JOB_STATUSES)) this.fetchJobId(this.job.jobId)
  }

  private created (): void {
    if (this.isConnected) {
      this.showDualRingSpinner()
      this.getActualDataForMap()
    }
  }

  private destroyed (): void {
    this.$q.loading.hide()
  }

  private getActualDataForMap (): void {
    this.fetchReservationTypes()
    this.fetchJobId(this.job.jobId)
  }

  public getSelectModal (): MatchFieldsSelect {
    return this.selectModal
  }

  private showDualRingSpinner (): void {
    this.$q.loading.show({
      spinner: DualRing as any
    })
  }
}
